(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["void-supply-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSection = (section) => {
      if (!section || section.dataset.voidInitialized === 'true') return;
      section.dataset.voidInitialized = 'true';

      const revealItems = section.querySelectorAll('[data-void-reveal]');
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      } else {
        const observer = new IntersectionObserver((entries, currentObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

        revealItems.forEach((item, index) => {
          item.style.transitionDelay = `${Math.min(index * 55, 220)}ms`;
          observer.observe(item);
        });
      }

      const slider = section.querySelector('[data-void-hero-slider]');
      const slides = slider ? Array.from(slider.querySelectorAll('[data-void-hero-slide]')) : [];
      const prevButton = slider?.querySelector('[data-void-slider-prev]');
      const nextButton = slider?.querySelector('[data-void-slider-next]');
      const dotsContainer = slider?.querySelector('[data-void-slider-dots]');
      const currentLabel = slider?.querySelector('[data-void-slider-current]');
      const totalLabel = slider?.querySelector('[data-void-slider-total]');
      const viewport = slider?.querySelector('[data-void-slider-viewport]');
      const autoplayEnabled = slider?.dataset.autoplay === 'true';
      let activeSlide = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let autoplayTimer = null;
      let touchStartX = 0;
      let touchStartY = 0;

      const formatSlideNumber = (number) => String(number).padStart(2, '0');

      const stopAutoplay = () => {
        if (!autoplayTimer) return;
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      };

      const startAutoplay = () => {
        stopAutoplay();
        if (!autoplayEnabled || prefersReducedMotion || slides.length < 2 || document.hidden) return;
        autoplayTimer = window.setInterval(() => {
          showSlide(activeSlide + 1, false);
        }, 10000);
      };

      const showSlide = (requestedIndex, restartAutoplay = true) => {
        if (slides.length < 1) return;
        activeSlide = (requestedIndex + slides.length) % slides.length;

        slides.forEach((slide, index) => {
          const isActive = index === activeSlide;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        if (dotsContainer) {
          dotsContainer.querySelectorAll('.void-supply__slider-dot').forEach((dot, index) => {
            const isActive = index === activeSlide;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-current', isActive ? 'true' : 'false');
          });
        }

        if (currentLabel) currentLabel.textContent = formatSlideNumber(activeSlide + 1);
        if (restartAutoplay) startAutoplay();
      };

      if (slider && slides.length > 1) {
        slider.classList.add('has-multiple-slides');

        if (dotsContainer) {
          dotsContainer.innerHTML = '';
          slides.forEach((_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'void-supply__slider-dot';
            dot.setAttribute('aria-label', `Show product image ${index + 1}`);
            dot.addEventListener('click', () => showSlide(index));
            dotsContainer.appendChild(dot);
          });
        }

        prevButton?.addEventListener('click', () => showSlide(activeSlide - 1));
        nextButton?.addEventListener('click', () => showSlide(activeSlide + 1));

        slider.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            showSlide(activeSlide - 1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            showSlide(activeSlide + 1);
          }
        });

        viewport?.addEventListener('touchstart', (event) => {
          const touch = event.changedTouches[0];
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
          stopAutoplay();
        }, { passive: true });

        viewport?.addEventListener('touchend', (event) => {
          const touch = event.changedTouches[0];
          const deltaX = touch.clientX - touchStartX;
          const deltaY = touch.clientY - touchStartY;

          if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY)) {
            showSlide(deltaX < 0 ? activeSlide + 1 : activeSlide - 1);
          } else {
            startAutoplay();
          }
        }, { passive: true });

        slider.addEventListener('mouseenter', stopAutoplay);
        slider.addEventListener('mouseleave', startAutoplay);
        slider.addEventListener('focusin', stopAutoplay);
        slider.addEventListener('focusout', (event) => {
          if (!slider.contains(event.relatedTarget)) startAutoplay();
        });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) stopAutoplay();
          else startAutoplay();
        });
      }

      if (totalLabel) totalLabel.textContent = formatSlideNumber(Math.max(slides.length, 1));
      showSlide(activeSlide, false);
      startAutoplay();

      const parallaxArea = section.querySelector('[data-void-parallax]');
      const productStage = parallaxArea?.querySelector('[data-void-product-stage]');
      const finePointer = window.matchMedia('(pointer: fine)').matches;

      /*
        Rotation-led 3D parallax. Translation is intentionally minimal so the
        product feels anchored in the hero while the cursor changes its viewing
        angle. The stage always returns to the raised -53px baseline and the
        original VOID SUPPLY resting attitude: rotateX(7deg) rotateY(-12deg)
        rotateZ(2deg).
      */
      if (parallaxArea && productStage && !prefersReducedMotion) {
        const motion = {
          x: 0,
          y: -53,
          rotate: 2,
          tiltX: 7,
          tiltY: -12,
          targetX: 0,
          targetY: -53,
          targetRotate: 2,
          targetTiltX: 7,
          targetTiltY: -12,
          raf: null
        };

        // Slow, damped interpolation gives the turn a substantial, premium feel
        // instead of snapping directly to the cursor position.
        const ease = 0.052;

        const renderMotion = () => {
          motion.x += (motion.targetX - motion.x) * ease;
          motion.y += (motion.targetY - motion.y) * ease;
          motion.rotate += (motion.targetRotate - motion.rotate) * ease;
          motion.tiltX += (motion.targetTiltX - motion.tiltX) * ease;
          motion.tiltY += (motion.targetTiltY - motion.tiltY) * ease;

          productStage.style.transform = `translate3d(${motion.x}px, ${motion.y}px, 0) rotateX(${motion.tiltX}deg) rotateY(${motion.tiltY}deg) rotateZ(${motion.rotate}deg)`;

          const stillMoving =
            Math.abs(motion.targetX - motion.x) > 0.03 ||
            Math.abs(motion.targetY - motion.y) > 0.03 ||
            Math.abs(motion.targetRotate - motion.rotate) > 0.015 ||
            Math.abs(motion.targetTiltX - motion.tiltX) > 0.015 ||
            Math.abs(motion.targetTiltY - motion.tiltY) > 0.015;

          if (stillMoving) {
            motion.raf = window.requestAnimationFrame(renderMotion);
          } else {
            motion.raf = null;
          }
        };

        const requestMotionFrame = () => {
          if (motion.raf === null) motion.raf = window.requestAnimationFrame(renderMotion);
        };

        if (finePointer) {
          parallaxArea.addEventListener('pointermove', (event) => {
            const bounds = parallaxArea.getBoundingClientRect();
            // x/y run from -0.5 to 0.5 across the hero stage.
            const x = (event.clientX - bounds.left) / bounds.width - 0.5;
            const y = (event.clientY - bounds.top) / bounds.height - 0.5;

            // Keep positional drift extremely light and let rotation do the work.
            // Translation: +/- 2px horizontal, +/- 1.5px vertical.
            // Rotation around the resting pose:
            //   X tilt: +/- 2deg
            //   Y tilt: +/- 3deg
            //   Z roll: +/- 0.15deg
            motion.targetX = x * 4;
            motion.targetY = -53 + (y * 3);
            motion.targetRotate = 2 + (x * 0.3);
            motion.targetTiltX = 7 - (y * 4);
            motion.targetTiltY = -12 + (x * 6);
            requestMotionFrame();
          });

          parallaxArea.addEventListener('pointerleave', () => {
            motion.targetX = 0;
            motion.targetY = -53;
            motion.targetRotate = 2;
            motion.targetTiltX = 7;
            motion.targetTiltY = -12;
            requestMotionFrame();
          });
        }
      }
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-void-supply-section]').forEach(initializeSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
